module.exports = __webpack_public_path__ + "fonts/icomoon.31dc40e.eot";